export class UploadPhotoDetails {
  title?: string;
  details?: string;
  acceptedFile?: string;
  roundCropper?: boolean;
  horizontalResize?: number;
  verticalResize?: number;
  aspectRatio?: number;
}
